import React, { useEffect } from 'react';
import EducationLayout from './EducationComponents/EducationLayout';
import EducationHero from './EducationComponents/EducationHero';
import EducationUseCases from './EducationComponents/EducationUseCases';
import StudentVsAdmin from './EducationComponents/StudentVsAdmin';
import EducationReadinessQuiz from './EducationComponents/EducationReadinessQuiz';
import EducationCaseStudy from './EducationComponents/EducationCaseStudy';
import EducationPricing from './EducationComponents/EducationPricing';
import EducationFoundersNote from './EducationComponents/EducationFoundersNote';
import EducationFAQ from './EducationComponents/EducationFAQ';
import Navigation from '../components/Navigation';
import Footer from '../../Landing/footer';

// Type declaration for SmushChat chatbot
declare global {
    interface Window {
        smushchatChatbot?: {
            init: (chatbotId: string, position: string, options: {
                iconType?: string;
                iconUrl?: string;
                buttonSize?: string;
                iconSize?: string;
                backgroundColor?: string;
            }) => void;
        };
    }
}

const EducationPage: React.FC = () => {
    useEffect(() => {
        // Load the chatbot script
        const script = document.createElement('script');
        script.src = 'https://smushlabs.ai/chatbot-loader.js';
        script.async = true;
        script.onload = () => {
            // Initialize the chatbot with your chatbot ID
            const CHATBOT_ID = '22691f44-f807-4a7e-82b9-130355c949b2';

            // Initialize the chatbot with position and toggle button settings
            if (window.smushchatChatbot) {
                window.smushchatChatbot.init(CHATBOT_ID, 'right', {
                    iconType: 'custom',
                    iconUrl: 'https://smushlabs.ai/favicon.ico',
                    buttonSize: 'medium',
                    iconSize: '100',
                    backgroundColor: '#002147' // Updated to match academic theme
                });
            }
        };
        document.body.appendChild(script);

        return () => {
            // Cleanup: remove script on unmount
            const existingScript = document.querySelector('script[src="https://smushlabs.ai/chatbot-loader.js"]');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, []);

    return (
        <EducationLayout>
            <Navigation />
            <EducationHero />
            <EducationCaseStudy />
            <StudentVsAdmin />
            <EducationUseCases />
            <EducationReadinessQuiz />
            <EducationPricing />
            <EducationFoundersNote />
            <EducationFAQ />
            <Footer />
        </EducationLayout>
    );
};

export default EducationPage;
